// Zentrale Modul-Definitionen. Deutsche Labels leben NUR hier im Frontend —
// der Backend kennt ausschließlich die module_keys (app_modules-Tabelle).
export const MODULE_DEFS = [
  { key: 'kontakte', label: 'Kontakte' },
  { key: 'kalender', label: 'Kalender' },
  { key: 'dokumente', label: 'Dokumente' },
  { key: 'bauvorhaben', label: 'Bauvorhaben' },
] as const;

export type ModuleKey = (typeof MODULE_DEFS)[number]['key'];

export const MODULE_LABELS: Record<string, string> = Object.fromEntries(
  MODULE_DEFS.map((m) => [m.key, m.label]),
);